export default function GeometryStatePill({ state }) {
  const map = {
    queued:          "bg-slate-100 text-slate-700 border-slate-300",
    running:         "bg-blue-50 text-blue-800 border-blue-200 sq-saving",
    verified:        "bg-emerald-50 text-emerald-800 border-emerald-300",
    review_required: "bg-amber-50 text-amber-900 border-amber-300",
    unsupported:     "bg-purple-50 text-purple-800 border-purple-300",
    failed:          "bg-rose-50 text-rose-800 border-rose-300",
    cancelled:       "bg-slate-200 text-slate-700 border-slate-400",
  };
  const label = {
    queued: "Queued",
    running: "Running",
    verified: "Verified",
    review_required: "Review required",
    unsupported: "Unsupported",
    failed: "Failed",
    cancelled: "Cancelled",
  }[state] || state;
  return (
    <span
      data-testid={`geometry-state-pill-${state}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs border ${map[state] || map.queued}`}
    >
      {label}
    </span>
  );
}
